/* @flow weak */
import * as React from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import SetupRosterPoll, { SetupRosterPollLoading } from './SetupRosterPoll.jsx';
import SetupRosteredClassesList from './SetupRosteredClassesList.jsx';
import trackView from 'lib/trackView';

import type { ProposedGroup } from './SetupRosterChoose';

type Props = {
  claimClasses: () => Promise<string>,
  proposedGroups: Array<ProposedGroup>,
};

type State = {
  statusEndpoint: ?string,
};

export class SetupRosterAll extends React.Component<Props, State> {
  state: State = {
    statusEndpoint: '',
  };

  componentDidMount() {
    this.props
      .claimClasses()
      .then(statusEndpoint => {
        this.setState({ statusEndpoint });
      })
      .catch(err => {
        console.error('Claim classes failed', err);
      });
  }

  groupsList() {
    return <SetupRosteredClassesList proposedGroups={this.props.proposedGroups} />;
  }

  render() {
    if (!this.props.proposedGroups) {
      return <LoadingIndicator align="center" />;
    }
    // Show the loading screen while we submit the first claim all
    // request. On complete, switch over to start the polling
    if (this.state.statusEndpoint) {
      return (
        <SetupRosterPoll
          statusEndpoint={this.state.statusEndpoint}
          proposedGroups={this.props.proposedGroups}
        />
      );
    } else {
      return <SetupRosterPollLoading groupsList={this.groupsList()} />;
    }
  }
}

const withGroups = graphql(
  gql`
    query getProposedGroupsAll {
      me {
        id
        uuid
        proposed_groups {
          id
          class_name
          parent_count
          student_count
        }
      }
    }
  `,
  {
    props: ({ data }) => {
      return data.me ? { proposedGroups: data.me.proposed_groups } : null;
    },
  }
);

const withMutation = graphql(
  gql`
    mutation RosterAll {
      claimAllProposedClasses {
        status
        status_endpoint
      }
    }
  `,
  {
    props({ mutate }) {
      return {
        claimClasses() {
          return mutate().then(
            ({ data: { claimAllProposedClasses } }) => claimAllProposedClasses.status_endpoint
          );
        },
      };
    },
  }
);

export default trackView(withMutation(withGroups(SetupRosterAll)), 'sis_roster_all');
